import { SignupRoles } from '../../../enums/signup-roles.enum';

export class SignupJoinRequest
{
    hoaName: string;
    name: string;
    email: string;
    address: string;
    city: string;
    state: string;
    zip: string;
    organizationId: number;
    captcha: string;

    constructor(request: any) {
        // for now, forcing signupForm value to match JoinRequest's expected model
        if (request && request.role === SignupRoles.HOMEOWNER) {
            this.hoaName = request.group.name;
            this.name = request.fullName;
            this.email = request.email;
            this.address = request.address.line1;
            if (request.address.line2 !== '') {
                this.address += ' ' + request.address.line2;
            }
            this.city = request.address.city;
            this.state = request.address.region.region;
            this.zip = request.address.postalCode;
            this.organizationId = request.group.id;
            this.captcha = request.captcha;
        }
    }
}
